// extracted by mini-css-extract-plugin
module.exports = {"btn":"Selector_btn__19oAS","selected":"Selector_selected__2BS3J","text":"Selector_text__I-xcW","selectedText":"Selector_selectedText__1TU7F"};